<script setup lang="ts">
import { defineProps, defineEmits, onUpdated, reactive } from "vue";
import Multiselect from "@vueform/multiselect";

const props = defineProps({
  modelValue: {
    type: [String, Number],
    required: false,
    default: "",
  },
  fetchOptions: {
    type: Function,
    required: true,
  },
  valorInicial: {
    type: Object,
  },
  label: String,
  required: Boolean,
  disabled: Boolean,
  placeholder: String,
});

const emit = defineEmits(["changeNome", "update:modelValue"]);
const onInput = (event: { value: number; label: string }) => {
  emit("update:modelValue", event?.value || undefined);
  emit("changeNome", event?.label || undefined);
};

onUpdated(async () => {
  if (props?.valorInicial?.value) {
    data.valorInicial.value = props?.valorInicial?.value;
    data.valorInicial.label = props?.valorInicial?.label;
  }
});

const data = reactive({
  valorInicial: { value: undefined, label: undefined },
});
</script>

<template>
  <div>
    <label v-if="props.label" :class="{ required: props.required }">
      {{ props.label }}
    </label>
    <Multiselect
      @change="onInput"
      v-model="data.valorInicial"
      mode="single"
      :disabled="props.disabled"
      :caret="false"
      :closeOnSelect="true"
      :searchable="true"
      :filterResults="false"
      :minChars="2"
      :resolveOnLoad="false"
      :required="props.required"
      :object="true"
      :delay="300"
      :placeholder="props.placeholder || 'Selecione uma das Opções'"
      noOptionsText="Digite para buscar"
      noResultsText="Nenhuma opção encontrada"
      :options="
        async function (query) {
          return await props.fetchOptions(query);
        }
      "
    />
  </div>
</template>
<style>
.multiselect-input {
  width: 100%;
  display: flex;
  align-items: center;
  min-height: 43.5px;

  box-sizing: border-box;
  cursor: pointer;
  position: relative;
  outline: none;
  border-radius: 0.475rem;
  background: #fdfdfd;
  border: 1px solid #bab6c3;

  background-image: var(--kt-form-select-indicator);
  background-repeat: no-repeat;
  background-position: right 1rem center;
  background-size: 16px 12px;
}

.is-disabled .multiselect-input {
  color: var(--kt-form-select-disabled-color);
  background-color: var(--kt-form-select-disabled-bg);
  border-color: var(--kt-form-select-disabled-border-color);
  /* background: #f9f9f9; */
}

.multiselect-placeholder,
.multiselect-single-label,
.multiselect-multiple-label {
  font-size: 14px;
  font-weight: 600 !important;
  color: #5e6278;
}

.is-single .multiselect-search,
.is-multiple .multiselect-search {
  display: flex;
  height: 100%;
  width: 100%;
  background: transparent;
}

.is-single.no-caret .multiselect-search input,
.is-multiple.no-caret .multiselect-search input {
  padding: 10px 35px 10px 14px;
}

.is-single .multiselect-search input,
.is-multiple .multiselect-search input {
  width: 100%;
  border: 0;
  padding: 10px 35px 10px 14px;
  outline: none;
  background: transparent;
  font-size: 14px;
  font-family: inherit;
  color: #5e6278;
}

.open-top .multiselect-options {
  transform: translateY(-100%);
  top: 2px;
  flex-direction: column-reverse;
  font-size: 14px;
}

.multiselect-option {
  display: flex;
  min-height: auto;
  padding: 2px 12px;
  box-sizing: border-box;
  color: #222;
  text-decoration: none;
  align-items: center;
  justify-content: flex-start;
  text-align: left;
  cursor: pointer;
  font-size: 14px;
  font-weight: normal;
}

.multiselect-option.is-pointed {
  color: #fff;
  background: #7e7c7c;
}

.multiselect-option.is-disabled {
  background: #7e7c7c;
  color: #a6a6a6;
  cursor: not-allowed;
}

.multiselect-option.is-selected {
  color: #fff;
  background: #7e7c7c;
}

.multiselect-option.is-selected.is-pointed {
  background: #7e7c7c;
}
</style>
